import { FC, memo } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

type NoteFieldProps = {
  label?: string
  content: string
}

const NoteField: FC<NoteFieldProps> = ({ label, content }) => (
  <Box flexDirection="column" gap="s8">
    {!!label && (
      <Text color="textSecondary" size="200">
        {label}
      </Text>
    )}
    <Box background="grey200" paddingX="s12" paddingY="s8" borderRadius={{ all: 'abs012' }}>
      <Text color="grey1000" size="200" whiteSpace="breakSpaces">
        {content}
      </Text>
    </Box>
  </Box>
)

export default memo(NoteField)
